// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","btnLongForm":"newLongFormModuleCTA_btnLongForm__5fKSe"};